export default __webpack_public_path__ + "static/media/mariog2.84b3036e.jpg";